/* eslint-disable max-len */
const HomeTitleImage = require('./HomeTitleImage');
const HomeCardOnlinePayment = require('./HomeCardOnlinePayment');
const HomeCardInperson = require('./HomeCardInperson');
const HomeCardPlugins = require('./HomeCardPlugins');
const HomeBanner = require('./HomeBanner');
const HomeBannerMobile = require('./HomeBannerMobile');
const HomeFooterSupport = require('./HomeFooterSupport');
const HomeFooterGitHub = require('./HomeFooterGitHub');
const HomeFooterStatusPage = require('./HomeFooterStatusPage');
const HomeNonDeveloperBanner = require('./HomeNonDeveloperBanner');
const HomePaymentLinkBanner = require('./HomePaymentLinkBanner');
const HomeDevProgramBanner = require('./HomeDevProgramBanner');

module.exports = { HomeTitleImage, HomeCardOnlinePayment, HomeCardInperson, HomeCardPlugins, HomeBanner, HomeBannerMobile, HomeFooterSupport, HomeFooterGitHub, HomeFooterStatusPage, HomeNonDeveloperBanner, HomePaymentLinkBanner, HomeDevProgramBanner };
